import L, { LatLngBounds } from 'leaflet';
export default class util {
    static isSp = false;
    /**
     * データファイルのURLを取得します
     * @param path ファイルパス
     */
    static getPath(path) {
        if (util.isSp) {
            return `../${path}`;
        }
        else {
            return path;
        }
    }
    /**
     * geoJsonファイル読込
     * @param filePath
     */
    static getGeoJson(filePath) {
        var geoJson;
        $.ajax({
            type: "GET",
            url: filePath,
            dataType: "json",
            timeout: config.ajaxtTimeout,
            cache: true,
            beforeSend: function (xhr) {
                xhr.overrideMimeType("application/json; charset=UTF-8");
            },
            async: false,
            success: function (data) {
                geoJson = data;
            },
            error: function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log(textStatus);
                console.log(errorThrown);
            }
        });
        return geoJson;
    }
    /**
     * クエリストリングを取得
     * @param queryStringValue
     */
    static getUrlVars(queryStringValue) {
        const url = window.location.search;
        const hash = url.slice(1).split('&');
        const max = hash.length;
        for (var i = 0; i < max; i++) {
            const array = hash[i].split('=');
            if (array[0] === queryStringValue) {
                return array[1];
            }
        }
        return '';
    }
    /**
     * メッシュコードから経緯度を取得（メッシュの中心）
     * @param meshcode
     */
    static meshToLatLng(meshcode) {
        const lat = (parseFloat(meshcode.substr(0, 2)) / 1.5 * 3600 + parseFloat(meshcode.substr(4, 1)) * 5 * 60 + Number(meshcode.substr(6, 1)) * 30 + 15) / 3600;
        const lng = ((parseFloat(meshcode.substr(2, 2)) + 100) * 3600 + parseFloat(meshcode.substr(5, 1)) * 7.5 * 60 + Number(meshcode.substr(7, 1)) * 45 + 22.5) / 3600;
        return new L.LatLng(lat, lng);
    }
    /**
     * メッシュコード枠の表示用座標データの取得
     * @param meshcode
     */
    static meshToLatLngBounds(meshcode) {
        let latlng = this.meshToLatLng(meshcode);
        let lat_w = (15.0 / 3600);
        let lng_w = (22.5 / 3600);
        let lat1 = latlng.lat - lat_w;
        let lat2 = latlng.lat + lat_w;
        let lng1 = latlng.lng - lng_w;
        let lng2 = latlng.lng + lng_w;
        return new LatLngBounds([[lat1, lng1], [lat2, lng2]]);
    }
    /**
     * 経緯度からメッシュコードを取得する
     * 参考：https://gist.github.com/gintarow/f7ba62e31f4aa0bfc2e6ced02fc5abf3
     * @param latlng
     */
    static latlngToMesh(latlng) {
        var lat = latlng.lat;
        var lng = latlng.lng;
        var p = Math.floor((lat * 60) / 40);
        var a = (lat * 60) % 40;
        var q = Math.floor(a / 5);
        var b = a % 5;
        var r = Math.floor((b * 60) / 30);
        var c = (b * 60) % 30;
        var s = Math.floor(c / 15);
        var d = c % 15;
        var t = Math.floor(d / 7.5);
        var u = Math.floor(lng - 100);
        var f = lng - 100 - u;
        var v = Math.floor((f * 60) / 7.5);
        var g = (f * 60) % 7.5;
        var w = Math.floor((g * 60) / 45);
        var h = (g * 60) % 45;
        var x = Math.floor(h / 22.5);
        var i = h % 22.5;
        var y = Math.floor(i / 11.25);
        let meshcode = "" + p + u + q + v + r + w;
        return meshcode;
    }
    /**
     * 2点の経緯度から距離を計算
     * @param latlng1
     * @param latlng2
     */
    static getDistance(latlng1, latlng2) {
        const radians = (deg) => { return deg * Math.PI / 180; };
        return 6378.14 * Math.acos(Math.cos(radians(latlng1.lat)) *
            Math.cos(radians(latlng2.lat)) *
            Math.cos(radians(latlng2.lng) - radians(latlng1.lng)) +
            Math.sin(radians(latlng1.lat)) *
                Math.sin(radians(latlng2.lat)));
    }
}
